import { makeDoneAppointmentPending } from "api/Pendings"
import { useMutation, useQueryClient } from "react-query"
import { toast } from "react-toastify"


export const useMakeDoneAppPending = () => {
    const queryClinet = useQueryClient();
    return useMutation(makeDoneAppointmentPending, {
        onSuccess: () => {
            queryClinet.invalidateQueries('appointmentPending');
            queryClinet.invalidateQueries(['widgetData','Appointment Pendings List'])

            toast.success('Pending is done')
        },
        onError: () => {
            toast.error('Something went wrong!')
        }
    })
}